module.exports = __webpack_public_path__ + "static/media/banner-photo526@2x.e3444ea9.webp";